import { API_BASE, parseJsonSafe } from "./api";

// src/api/tasks.ts → تابع createTask
export const createTask = async (projectId: number, title: string, description?: string) => {
  const username = localStorage.getItem("username") ?? "";
  
  const res = await fetch(`${API_BASE}/projects/${projectId}/tasks?username=${encodeURIComponent(username)}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title, description })
  });

  if (!res.ok) {
    const err = await res.text();
    throw new Error(`خطا در ساخت تسک: ${res.status} - ${err}`);
  }

  const data = await res.json();

  // مهم: id واقعی از سرور رو برگردون!
  return {
    id: data.taskItemId ?? data.id ?? 0,  // این خط حیاتیه!
    taskItemId: data.taskItemId,
    title: data.title,
    description: data.description ?? "",
    isDone: data.isDone ?? false,
    createdById: data.createdById ?? Number(localStorage.getItem("userId")),
    createdAt: data.createdAt ?? new Date().toISOString(),
    updatedAt: data.updatedAt ?? new Date().toISOString(),
    notes: []
  };
};

export async function updateTask(projectId: number, taskId: number, data: any) {
  const username = localStorage.getItem("username") ?? "";
  const res = await fetch(`${API_BASE}/projects/${projectId}/tasks/${taskId}?username=${encodeURIComponent(username)}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  });

  if (res.status === 403) {
    throw new Error("شما اجازه ویرایش این تسک را ندارید");
  }
  if (res.status === 404) {
    throw new Error("تسک پیدا نشد");
  }
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`ویرایش تسک ناموفق بود (${res.status}): ${txt}`);
  }

  const serverTask = await parseJsonSafe(res, data);
  return {
    id: serverTask.id ?? serverTask.taskItemId ?? taskId,
    title: serverTask.title ?? data.title ?? "",
    description: serverTask.description ?? data.description ?? "",
    isDone: serverTask.isDone ?? data.isDone ?? false,
    createdById: serverTask.createdById ?? data.createdById ?? null,
    createdAt: serverTask.createdAt ?? data.createdAt ?? new Date().toISOString(),
    notes: (serverTask.notes ?? data.notes ?? []).map((n: any) => ({
      id: n.id ?? n.taskNoteId ?? 0,
      content: n.content ?? "",
      createdById: n.createdById ?? 0,
      createdAt: n.createdAt ?? new Date().toISOString()
    }))
  };
}

export async function deleteTask(projectId: number, taskId: number) {
  const username = localStorage.getItem("username") ?? "";
  const res = await fetch(`${API_BASE}/projects/${projectId}/tasks/${taskId}?username=${encodeURIComponent(username)}`, {
    method: "DELETE"
  });

  if (res.status === 403) {
    throw new Error("شما اجازه حذف این تسک را ندارید");
  }
  if (res.status === 404) {
    throw new Error("تسک پیدا نشد");
  }
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`حذف تسک ناموفق بود (${res.status}): ${txt}`);
  }

  return true;
}
